<script setup lang="ts">
import DOMPurify from 'dompurify';

const props = defineProps({
	htmlContent: {
		type: String,
		default: '',
	},
});

const sanitizedHtml = ref('');

watchEffect(() => {
	let html = props.htmlContent || '';
	// Only convert if it doesn't look like HTML already
	if (!/<[a-z][\s\S]*>/i.test(html)) {
		html = html.replace(/\n/g, '<br>');
	}
	sanitizedHtml.value = DOMPurify.sanitize(html);
});
</script>

<template>
	<div
		v-if="htmlContent"
		v-html="sanitizedHtml"
	/>
</template>
